import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { ReduxState } from "helpers/helper";
import {
  useMenuItems,
  MenuItem,
  BaseMenuItem,
  getMenuItemUrl
} from "./menuItems";
import SidebarListItem from "./SidebarListItem";
import { TSelectedMenu } from "./Sidebar";

interface MainSideMenuProps {
  isMobile: boolean;
  isNavOpen: boolean;
  selectedMenu: TSelectedMenu;
}

interface IMainSideMenuContext extends Omit<MainSideMenuProps, "selectedMenu"> {
  isNavOpen: boolean;
  isActive: (item: MenuItem | BaseMenuItem) => boolean;
  setSelectedItem: (item: MenuItem) => void;
}

export const MainSideMenuContext = React.createContext<IMainSideMenuContext>(
  {} as any
);

const MainSideMenu: React.FC<MainSideMenuProps> = props => {
  const user = useSelector<ReduxState, any>(state => state.auth.user);
  const { menuItems, isActive, setSelectedItem } = useMenuItems(
    props.selectedMenu
  );

  return (
    <ul
      role="menu"
      className={classNames("side_nav_ul-menu", {
        "max-height-switch":
          user?.enable_gateway && user?.compperms?.gateway_admin
      })}
    >
      <MainSideMenuContext.Provider
        value={{
          isMobile: props.isMobile,
          isNavOpen: props.isNavOpen,
          isActive,
          setSelectedItem
        }}
      >
        {menuItems.map(item => (
          <SidebarListItem
            key={`${item.label}-${getMenuItemUrl(item)}`}
            item={item}
            isNavOpen={props.isNavOpen}
            hasSubMenu
          />
        ))}
      </MainSideMenuContext.Provider>
    </ul>
  );
};

export default MainSideMenu;
